import { useLingui } from "@lingui/react";
import { ApiDatafanPipeline, FailureApi } from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery, UseQueryOptions } from "react-query";

import {
  IDatafanPipeline,
  useDatafanPipelineAggregation,
} from "@/hooks/use_datafan/use_datafan_pipeline_aggregation";

const KEY = "datafan.pipeline";

type Response = Await<ReturnType<typeof ApiDatafanPipeline.get>>;

export const useQueryDatafanPipeline = (
  pipelineId: string | number,
  options?: Omit<
    UseQueryOptions<Response, FailureApi, IDatafanPipeline>,
    "queryKey" | "queryFn" | "select"
  >,
) => {
  const { i18n } = useLingui();
  const lang = i18n.locale === "ru" ? "ru" : "en";
  const aggregatePipeline = useDatafanPipelineAggregation();

  return useQuery<Response, FailureApi, IDatafanPipeline>(
    [KEY, pipelineId],
    () =>
      ApiDatafanPipeline.get({
        path: { id: Number(pipelineId) },
        query: { lang },
      }),
    {
      ...((options || {}) as any),
      select: (data) => aggregatePipeline(data.results[0]),
    },
  );
};

useQueryDatafanPipeline.KEY = KEY;
